import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=5e70fa7f&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
import style0 from "./Icon.vue?vue&type=style&index=0&id=5e70fa7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70fa7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e70fa7f')) {
      api.createRecord('5e70fa7f', component.options)
    } else {
      api.reload('5e70fa7f', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=5e70fa7f&scoped=true", function () {
      api.rerender('5e70fa7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/Icon.vue"
export default component.exports